<template>
    <div>
        <v-card elevation="0">
            <v-card-text>
                <v-container>
                    <v-file-input accept=".csv" label="Choose ONE CSV file" outlined counter v-model="userFile"
                        id="uploadFile" hint="File Upload" persistent-hint :rules="[v => /^csv$/i.test(v.name.split('.').splice(-1)[0]) || 'File must be a CSV!']" @change="validateForm" dense
                    >
                        <template v-slot:append-outer>
                            <v-dialog
                                v-model="dialog"
                                persistent
                                width="650px"
                            >
                                <template v-slot:activator="{ on, attrs }" >
                                    <v-btn :disabled="submitDisabled" color="#41729F" v-bind="attrs" v-on="on" style="color: white; text-align: center;">Upload</v-btn>
                                </template>
                                <v-card>
                                    <v-form target="hiddenFrame" @submit="submitForm">
                                        <v-card-title style="text-align: center; background-color: #DAF1F4;" class="text-h5">
                                            Confirm Upload?
                                        </v-card-title>
                                        <v-divider></v-divider><br />
                                        <v-card-text style="text-align: center; font-size: 18px;">
                                            You are about to upload <b>{{ filename }}</b>. <br /><br />
                                            Uploading this file will <b>overwrite</b> the course timetable database. Proceed?
                                        </v-card-text>
                                        <v-card-actions>
                                            <v-spacer></v-spacer>
                                            <v-btn color="#E53935" text @click="dialog = false">
                                                Cancel
                                            </v-btn>
                                            <v-btn color="green darken-1" text type="submit" @click="dialog = false" :loading="loading">
                                                OK
                                            </v-btn>
                                        </v-card-actions>
                                    </v-form>
                                </v-card>
                            </v-dialog>
                        </template>
                    </v-file-input>
                </v-container>
                <v-container>
                    <v-card elevation="0">
                        <v-card-title>
                            <v-text-field v-model="search" append-icon="mdi-magnify" label="Search" single-line hide-details dense></v-text-field>
                        </v-card-title>
                        <v-data-table :headers="headers" :items="timetable" :search="search" :loading="timetableloading" loading-text="Loading Timetable..."
                            show-expand :expanded.sync="expanded" single-expand :items-per-page="5" dense
                        >
                            <template v-slot:top>
                                <v-card-subtitle style="width:100%; text-align:right;">
                                    <i>Last uploaded on <b>{{ uploadeddate }}</b> by <b>{{ uploadedby }}</b></i>
                                </v-card-subtitle>
                            </template>
                            <template v-slot:item.mon="{ item }">
                                <v-checkbox v-model="item.mon" disabled true-value="Mon"></v-checkbox>
                            </template>
                            <template v-slot:item.tues="{ item }">
                                <v-checkbox v-model="item.tues" disabled true-value="Tue"></v-checkbox>
                            </template>
                            <template v-slot:item.wed="{ item }">
                                <v-checkbox v-model="item.wed" disabled true-value="Wed"></v-checkbox>
                            </template>
                            <template v-slot:item.thurs="{ item }">
                                <v-checkbox v-model="item.thurs" disabled true-value="Thu"></v-checkbox>
                            </template>
                            <template v-slot:item.fri="{ item }">
                                <v-checkbox v-model="item.fri" disabled true-value="Fri"></v-checkbox>
                            </template>
                            <template v-slot:expanded-item="{ headers, item }">
                                <td :colspan="headers.length">
                                    <br />
                                    <v-row>
                                        <v-col cols="5">
                                            <v-simple-table style="width: 100%; border-collapse:collapse;">
                                                <template v-slot:default>
                                                    <tbody>
                                                        <tr style="height: 20px">
                                                            <th>Department</th>
                                                            <td>{{ item.academicdepartment }}</td>
                                                        </tr>
                                                        <tr style="height: 20px">
                                                            <th>Campus</th>
                                                            <td>{{ item.campus }}</td>
                                                        </tr>
                                                        <tr style="height: 20px">
                                                            <th>Location</th>
                                                            <td>{{ item.location }}</td>
                                                        </tr>
                                                        <tr style="height: 20px">
                                                            <th>Capacity</th>
                                                            <td>{{ item.enrlcap }}</td>
                                                        </tr>
                                                        <tr style="height: 20px">
                                                            <th>Instructor</th>
                                                            <td>{{ item.instructorname }}</td>
                                                        </tr>
                                                        <tr style="height: 20px">
                                                            <th>Session</th>
                                                            <td>{{ item.sessioncode }}</td>
                                                        </tr>
                                                        <tr style="height: 20px">
                                                            <th>Time</th>
                                                            <td>{{ item.starttime }}-{{ item.endtime }}</td>
                                                        </tr>
                                                    </tbody>
                                                </template>
                                            </v-simple-table>
                                        </v-col>
                                        <v-col cols="7">
                                            <v-simple-table style="width: 100%; border: none; border-collapse:collapse;">
                                                <template v-slot:default>
                                                    <tbody>
                                                        <tr style="height: 20px">
                                                            <th>Academic Group</th>
                                                            <td>{{ item.acadgroup }}</td>
                                                        </tr>
                                                        <tr style="height: 20px">
                                                            <th>Facility</th>
                                                            <td>{{ item.facilityid }}</td>
                                                        </tr>
                                                        <tr style="height: 20px">
                                                            <th>Associated Class</th>
                                                            <td>{{ item.associatedclass }}</td>
                                                        </tr>
                                                        <tr style="height: 20px">
                                                            <th rowspan="2">Description</th>
                                                            <td>{{ item.descr }}</td>
                                                        </tr>
                                                        <tr style="height: 20px">
                                                            <td>{{ item.descrlong }}</td>
                                                        </tr>
                                                    </tbody>
                                                </template>
                                            </v-simple-table>
                                        </v-col>
                                    </v-row>
                                    <br />
                                </td>
                            </template>
                        </v-data-table>
                    </v-card>
                </v-container>
            </v-card-text>
        </v-card>
        <v-snackbar
            v-model="snackbar"
            :color="snackbarcolor"
            :timeout="timeout"
        >
            {{ text }}
        </v-snackbar>
    </div>
</template>
<script>
export default {
    data(){
        return {
            host: location.hostname.toString(),
            userFile: "",
            filename: "",
            submitDisabled: true,
            snackbar: false,
            snackbarcolor: "",
            text: "",
            timeout: 3500,
            loading: false,
            dialog: false,
            timetableloading: false,
            search: "",
            expanded: [],
            headers: [
                {text: "Source" , value: "source"},
                {text: "Stream" , value: "strm"},
                {text: "Section" , value: "classsection"},
                {text: "Subject" , value: "subject-resolved"},
                {text: "Catalog" , value: "catalognbr"},
                {text: "Class #" , value: "classnbr"},
                {text: "Component", value: "ssrcomponent"},
                {text: "Mon", value: "mon"},
                {text: "Tue", value: "tues"},
                {text: "Wed", value: "wed"},
                {text: "Thurs", value: "thurs"},
                {text: "Fri", value: "fri"},
                {text: '', value: 'data-table-expand'},
            ],
            timetable: [],
            uploadeddate: "",
            uploadedby: ""
        }
    },
    methods: {
        splitMeetingTime(meetingtime){
            if (meetingtime.split(" ").length == 3){
                return meetingtime.split(" ")[1]+" "+meetingtime.split(" ")[2]
            }else {
                return meetingtime.split(" ")[1]
            }
        },
        validateForm(){
            const that = this;
            //Upload Button control

            if(that.userFile === null || that.userFile.length == 0){
                that.submitDisabled = true;
            }else {
                that.filename = document.getElementById("uploadFile").files[0].name;
                if(that.filename.split(".").slice(-1)[0].match(/^csv/i)){ //Checks if the uploaded file extension is .csv
                    that.submitDisabled = false;
                }else{
                    that.submitDisabled = true;
                }
            }
        },
        submitForm(){
            const that = this;
            that.loading = true;

            let api= 'https://'+that.host+'/cgi-bin/cupe-app-api/api.py';
            const formData = new FormData();
            formData.append("mode", "timetableUpload");
            formData.append("fileTimetable", that.userFile);

            fetch(api, {
                method: 'POST',
                body: formData
            })
            .then(function(response){
                return response.json();
            })
            .then(function (data) {
                if(data.result.match(/ok/i)){
                    that.loading = false;
                    that.setSnackbar("Successful: "+data.message.toString(), "green");
                    that.submitDisabled = true;
                    that.userFile = "";
                    that.dialog = false;
                    that.showtimetable();
                }else {
                    that.dialog = false;
                    that.setSnackbar("Warning: "+data.message.toString(), "orange");
                    that.loading = false;
                }
            })
            .catch(function (err) {
                that.dialog = false;
                that.setSnackbar("Error occurred : "+err.toString(), "red");
                that.loading = false;
            })

        },
        showtimetable(){
            const that = this;
            that.timetableloading = true;
            that.timetable = [];

            let api = 'https://'+that.host+'/cgi-bin/cupe-app-api/api.py?mode=timetableSearch';

            //API calling
            fetch(api)
                .then(function (response) {
                    return response.json();
                })
                .then(function (resultData) {
                    if(!resultData.result.match(/^OK/i)){
                        that.setSnackbar("Warning: "+resultData.message, "#EF6C00"); //orange
                    }else {
                        resultData.data.forEach(element => {
                            if(element.hasOwnProperty('system')){
                                that.translateTimestamp(element["timestamp"]);
                                that.uploadedby = element["uploadedByCommonName"];
                            }else {
                                that.timetable.push(element);
                            }
                        });
                    }
                    that.timetableloading = false;
                })
                .catch(function(err){
                    that.setSnackbar("Error: "+err.toString(), "#E57373"); //light red
                })
            //End of API calling
        },
        translateTimestamp(timestamp){
            const that = this;

            var date = new Date(parseInt(timestamp));

            that.uploadeddate = date.toDateString();
        },
        setSnackbar(msg, color){ //Sets Snackbar
            const that = this;
            that.snackbar = true;
            that.snackbarcolor = color;
            that.text = msg;
        }
    },
    created(){
        const that = this;
        that.showtimetable();
    }
}
</script>
<style scoped>
.v-data-table >>> .v-data-table__wrapper tbody tr.v-data-table__expanded__content {
  box-shadow: none;
}
</style>